import React from 'react'
import axios from 'axios'
import LoadingPage from './LoadingPage'
import PorovnaniZastupitelu from './PorovnaniZastupitelu';

class PorovnaniZastupiteluWrapper extends React.Component {  
    constructor(props) {
        super(props);

        this.state = {
            memberOptions: undefined
        }

        this.componentDidMount = this.componentDidMount.bind(this);
    }

    async componentDidMount() {
        let pathNameArr = window.location.pathname.split('/')
        let currentCouncil = pathNameArr[pathNameArr.length-3]
        await axios.get( this.props.apiBaseUrl + 'FE/' + currentCouncil + '/dropdownMemberOptions').then((response) => {
            this.setState({memberOptions: response.data});
        });
    }
    
    render() {
        const { memberOptions } = this.state;
        const { baseUrl, apiBaseUrl } = this.props;

        if (baseUrl !== undefined && apiBaseUrl !== undefined && memberOptions !== undefined) {
            return (
                <PorovnaniZastupitelu 
                    baseUrl={ baseUrl } 
                    apiBaseUrl={ apiBaseUrl } 
                    memberOptions={ memberOptions }
                />
            );
        } else {
            return (
                <LoadingPage />
            );   
        }
    }
}

export default PorovnaniZastupiteluWrapper